module.exports = __webpack_public_path__ + "img/255.fd192eca.png";